import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function About() {
  const { t, lang } = useLanguage();

  return (
    <section className="about section" id="about">
      <div className="container">
        <h2 className="section-title">{t('about.title')}</h2>
        <div className="about-content">
          <p>{t('about.text1')}</p>
          <p>{t('about.text2')}</p>
          <p>{t('about.text3')}</p>
          <div className="about-stats">
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">
                {lang === 'fr' ? 'Applications' : 'Applications'}
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">
                {lang === 'fr' ? 'Cloud & Temps reel' : 'Cloud & Real-time'}
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">
                {lang === 'fr' ? 'Support technique' : 'Technical support'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
